import React from 'react';
import { Card, Row, Stack } from 'library/ui';

import ShiftCardMenu from '../../BusinessCalendar/ShiftCard/ShiftCardMenu';
import { BusinessSlotHeader } from './BusinessSlotHeader';
import { BusinessSlotSchedule } from './BusinessSlotSchedule';
import { BusinessSlotProgressDetails } from './BusinessSlotProgressDetails';

import { BusinessSlot, ShiftJob } from 'models';
import type { BusinessJobResponse } from '../models';
import { styled } from '@mui/material';

export function BusinessJobShiftSlot({
    slot,
    job,
    getJob,
    tone = 'muted',
}: {
    slot: BusinessSlot;
    job: BusinessJobResponse['job_details'] | ShiftJob;
    getJob: () => void;
    tone?: 'muted' | 'default';
}) {
    const appt = slot.appointments.length ? slot.appointments[0] : undefined;
    const shiftProvider = appt && appt.providers.length ? appt.providers[0] : undefined;
    const provider = shiftProvider?.provider;
    const provider_id = shiftProvider?.provider_id;
    const status = appt?.providers?.[0]?.status ?? 'UNFILLED';

    return (
        <StyledCard tone={tone} fullHeight>
            <Stack gap="sm">
                <Row justify="between" align="center">
                    <BusinessSlotHeader provider={provider} headline={job.headline} />
                    <ShiftCardMenu
                        provider_id={provider_id}
                        provider={provider ?? undefined}
                        slot={slot}
                        ongoing_request={slot.ongoing_request}
                        status={status}
                        refresh={getJob}
                        needs718bFiling={shiftProvider?.needs_718b_filing}
                    />
                </Row>
                <BusinessSlotSchedule slot={slot} job={job} provider={shiftProvider} refresh={getJob} />
                <BusinessSlotProgressDetails slotAddedAt={slot.added_at} appt={appt} shiftProvider={shiftProvider} />
            </Stack>
        </StyledCard>
    );
}

const StyledCard = styled(Card)({
    flex: '1 1 320px',
    maxWidth: 500,
});
